import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchPDFOfaUser, formatDateToDDMMYYYY, getCertificateByID, BaseURL } from "../Functions/certificate";
import PDFViewer from "./PDFViewer";
import FooterForVerification from "./FooterForVerivication";


export default function CertificateView() {
  const [pdfURL, setPdfUrl] = useState(null);
  const [certificate, setCertificate] = useState({ name: "", date: "" });
  const params = useParams();
  console.log("cer", certificate)

  
  const ithm ={
       logo : "https://verification.othm.org.uk/img/logo-default.png",
       text :"This document is valid and was issued by OTHM Qualifications to"
  }

  const iosh = {
    logo :"https://very.iosh.com/img/logo-default.png",
    text :"This document is valid and was issued by IOSH (Institution of Occupational Safety and Health) to"
  }
  const local ={
    logo:"",
    text:""
  }

  const certificateCompany = certificate?.issuedBy == "IOSH" ? iosh : certificate.name == "" ? local:ithm; 

  useEffect(() => {
    const fetchPDF = async () => {
      try {
        const response = await fetchPDFOfaUser(params.id);
        const certificateDetail = await getCertificateByID(params.id);
        // console.log("Certificate response", certificateDetail)
        setCertificate(certificateDetail.data)

        if (response.status) {
          // console.log("Fetch pdf", response)
          setPdfUrl(response.data);
        } else {
          console.log("Failed: ", response.message);
        }
      } catch (error) {
        console.log("Error in fetching PDF", error);
      }
    };
    fetchPDF();
  }, []);
  return (
    <div
      className="w-screen  bg-no-repeat bg-cover   "
      style={{
        backgroundImage: "url('https://very.iosh.com/images/hex_map_bg.jpg')",
      }}
    >
      <div className="h-fit bg-white rounded-lg shadow-lg w-screen md:[95%] mx-0 p-3 mb-4">
        <div className="flex  justify-between items-center p-4">
          <img
            src={certificateCompany.logo}
            alt=""
            className="md:h-20  h-10 object-contain"
          />
          <img
            src="https://very.iosh.com/images/Smart-Verify-Plus-Logo.png"
            alt="Smart Verify Plus"
            className="md:h-20 object-contain h-10"
          />
        </div>
        <div className="py-3 my-3 bg-[#007A5A] rounded-sm flex items-center text-white pl-1"> <span><svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" className="text-white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
        </span><span className="pl-2 text-sm">
            {certificate.name && (
              <> 
               {certificateCompany.text} {certificate.name} on {formatDateToDDMMYYYY(certificate.dateOfIssue)}
              </>
            )}
          </span></div>


        <div className="border-t border-gray-300">
          <PDFViewer pdfUrl={`${BaseURL}certificate/getPDF/${params.id}`} />
        </div>

      </div>
      <FooterForVerification />

    </div>
  );
}
